<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.updateProduct") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="12"
            identifier="product_image"
            :preSelectedImage="data.image.path"
            :placeholder="$t('PLACEHOLDERS.image')"
            @selectImage="selectImage"
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.nameAr"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.nameEn"
            required
          />

          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model.trim="data.descriptionAr"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model.trim="data.descriptionEn"
            required
          />

          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.package_price')"
            v-model.trim="data.price"
            required
          />

          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditProduct",

  data() {
    return {
      isWaitingRequest: false,
      data: {
        image: {
          path: null,
          file: null,
        },
        nameAr: null,
        nameEn: null,
        descriptionAr: null,
        descriptionEn: null,
        price: null,
        active: true,
      },
    };
  },

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },

    async submitForm() {
      const requestData = new FormData();

      requestData.append("name[ar]", this.data.nameAr || "");
      requestData.append("name[en]", this.data.nameEn || "");
      requestData.append("description[ar]", this.data.descriptionAr || "");
      requestData.append("description[en]", this.data.descriptionEn || "");
      requestData.append("price", this.data.price || 0);
      requestData.append("is_active", this.data.active ? 1 : 0);
      requestData.append("_method", "put");

      if (this.data.image.file) {
        requestData.append("image", this.data.image.file);
      }

      try {
        await this.$axios({
          method: "POST",
          url: `products/${this.$route.params.id}`,
          data: requestData,
        });
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/products/all" });
      } catch (error) {
        this.$message.error(error?.response?.data?.message);
      } finally {
        this.isWaitingRequest = false;
      }
    },

    async showProduct() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `products/${this.$route.params.id}`,
        });
        const item = res.data.data?.product || res.data.data;

        this.data.image.path = item?.image;
        this.data.nameAr = item?.name_ar;
        this.data.nameEn = item?.name_en;
        this.data.descriptionAr = item?.description_ar;
        this.data.descriptionEn = item?.description_en;
        this.data.price = item?.price;
        this.data.active = !!item?.is_active;
      } catch (error) {
        console.log(error?.response?.data?.message);
      }
    },
  },

  created() {
    this.showProduct();
  },
};
</script>
